import $ from 'jquery'
import Siema from 'siema';

$(window).scroll(function () {
	if (($(window).scrollTop() >= 1)) {
		$(".header").addClass("sticked");
	} else {
		$(".header").removeClass("sticked");
	}
});

function siemaInitRefs() {

	const mySiema = new Siema({
		selector: '.ref_slider',
		duration: 200,
		easing: 'ease-out',
		loop: true
	});

	const prev = document.querySelector('.prev');
	const next = document.querySelector('.next');

	prev.addEventListener('click', () => mySiema.prev());
	next.addEventListener('click', () => mySiema.next());

	Siema.prototype.addPagination = function() {
		for (let i = 0; i < this.innerElements.length; i++) {
			const btn = document.createElement('a');
			btn.setAttribute("class", "pag_but" );
			btn.textContent = i;
			btn.addEventListener('click', () => this.goTo(i));
			this.selector.appendChild(btn);
		}
	}
	mySiema.addPagination();
}
siemaInitRefs()

function initAccordion() {

	var accordions = document.getElementsByClassName("accordion");

	for (var i = 0; i < accordions.length; i++) {
		accordions[i].onclick = function() {
			this.classList.toggle('is-open');

			var content = this.nextElementSibling;
			if (content.style.height) {

				content.style.height = null;
			} else {

				content.style.height = content.scrollHeight + "px";
			}
		}
	}
}
initAccordion();

jQuery('.tel_to').click(function() {
	var pageURL = $(location).attr("href");
	var buttonText = jQuery(this).text();
	ga('send', 'event', 'Tel', 'Click', pageURL);
	fbq('track', 'Contact');
	console.log(pageURL);
});
jQuery('.mail_to').click(function() {
	var pageURL = $(location).attr("href");
	var buttonText = jQuery(this).text();
	ga('send', 'event', 'Mailto', 'Click', pageURL);
	fbq('track', 'AddToWishlist');
	console.log(pageURL);
});



// WEBPACK FOOTER //
// ./resources/assets/js/homemobile.js